export enum TargetValueType {
	Response = 1,
	ResponseMin = 2,
	ResponseMax = 3,
	CustomerField = 4,
	CultureCode = 5,
	UrlParam = 6,
}
